"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.path = exports.responseSchema = exports.requestSchema = void 0;
const zod_1 = require("zod");
exports.requestSchema = zod_1.z.object({
    propertyIds: zod_1.z.array(zod_1.z.number().int().positive()).max(1000),
});
exports.responseSchema = zod_1.z.object({
    zones: zod_1.z.array(zod_1.z.object({
        zoneId: zod_1.z.number(),
        propertyId: zod_1.z.number(),
        cropIds: zod_1.z.array(zod_1.z.number()),
    })),
});
exports.path = '/irrigation/zone-crops';
//# sourceMappingURL=index.js.map